var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.$style.starDescriptions
  }, [_c('p', {
    staticClass: "p2"
  }, [_vm._v(_vm._s(_vm.leastStarDescription))]), _c('p', {
    staticClass: "p2"
  }, [_vm._v(_vm._s(_vm.mostStarDescription))])]), _c('div', {
    class: _vm.$style.starRatingContainer
  }, _vm._l([1, 2, 3, 4, 5], function (star) {
    return _c('div', {
      key: star,
      class: _vm.$style.star,
      on: {
        "click": function click($event) {
          return _vm.updateStarRating(star);
        },
        "mouseenter": function mouseenter() {
          _vm.hoverValue = star;
          _vm.isHovering = true;
        },
        "mouseleave": function mouseleave() {
          _vm.isHovering = false;
        }
      }
    }, [_c('BaseIcon', {
      attrs: {
        "name": {
          prefix: _vm.isFilled(star) ? 'fas' : 'far',
          iconName: 'star'
        }
      }
    })], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }